module.exports = __webpack_public_path__ + "static/media/front.e1d6f737.svg";